/**
 * EditingLocationChip — read-only context chip for per-location areas.
 *
 * Location selection lives in the global header <LocationFilter/> (Brett's
 * call: don't duplicate the control in the panel). This chip only REFLECTS
 * that selection so per-location settings always show which location they
 * edit; with "All Locations" active it becomes an amber prompt instead.
 */
import { AlertTriangle, MapPin } from 'lucide-react';
import { useLocation } from '@/contexts/LocationContext';

export function EditingLocationChip() {
  const { selectedLocation } = useLocation();

  if (!selectedLocation) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-md border border-amber-200 bg-amber-50 px-2.5 py-1.5 text-xs font-medium text-amber-800">
        <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        Select a location in the header to edit its settings
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 rounded-md border bg-muted/50 px-2.5 py-1.5 text-xs text-muted-foreground">
      <MapPin className="h-3.5 w-3.5 shrink-0 text-primary" aria-hidden="true" />
      Editing <span className="font-semibold text-foreground">{selectedLocation.name}</span>
      <span aria-hidden className="hidden sm:inline">· set in header ↑</span>
    </span>
  );
}
